// extracted by mini-css-extract-plugin
export var button = "SashBanner-module--button--Gnbgn";
export var inner = "SashBanner-module--inner--geKni";
export var link = "SashBanner-module--link--KkSYy";
export var message = "SashBanner-module--message--LfOFX";
export var wrapper = "SashBanner-module--wrapper--5ao8n";